import React from 'react'
import { MDXTag } from '@mdx-js/tag'


import DefaultLayout from "/var/lib/jenkins/jobs/app-styleguide/workspace/src/templates/page.js"

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = DefaultLayout
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             Layout={this.layout} layoutProps={Object.assign({}, layoutProps, props)}
             components={components}>

<MDXTag name="h3" components={components} props={{"id":"button-alignment"}}><MDXTag name="a" components={components} parentName="h3" props={{"href":"#button-alignment","aria-label":"button alignment permalink","class":"anchor"}}></MDXTag>{`button alignment`}</MDXTag>
<blockquote>
  Buttons should be ranged either left or right, but the decision about which side should be on a case-by-case basis.
</blockquote>

<MDXTag name="p" components={components}>{`This is because making all buttons on Tes ranged on one or other side all the time (in the name of consistency) will be too restrictive in some cases.
However:`}</MDXTag>
<MDXTag name="ul" components={components}>
<MDXTag name="li" components={components} parentName="ul">{`On desktop: we prefer forms to have buttons ranged left.`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`On desktop: large Windows & Forms get the button on the bottom left.`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`On desktop: small Windows & Dialogues get the button on the bottom right.`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`On mobile: we prefer all action buttons to be one the right (and their secondary/cancel items to their left)`}</MDXTag>
</MDXTag>
           </MDXTag>
  }
}

export const _frontmatter = {};

  